import { Box, DashboardModuleListItem } from '@domain-group/suit-theme'

import useAgencyProviderPriceOverride from '@hooks/useAgencyProviderPriceOverride'

import { confirmDelete } from '@functions/entity'

const PriceOverrideActions = (props: { priceOverride: { id: number } }) => {
  const { priceOverride } = props

  const {
    callbacks: {
      createOrEditAgencyProviderPriceOverride,
      deleteAgencyProviderPriceOverride: deleteFn,
    },
  } = useAgencyProviderPriceOverride(priceOverride)

  const confirmDeletePayload = {
    callbacks: {
      deleteFn,
    },
    strings: {
      confirmString: 'Are you sure?',
      entityName: 'Price Override',
    },
  }

  return (
    <Box justifyContent="center">
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Icon
        marginRight="medium"
        onClick={() => createOrEditAgencyProviderPriceOverride()}
        type="edit"
      />

      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Icon
        onClick={() => confirmDelete(confirmDeletePayload)}
        type="delete"
      />
    </Box>
  )
}

export default PriceOverrideActions
